// Script pour gérer les boutons de quantité
document.addEventListener('DOMContentLoaded', function() {
    
    // Sélectionner tous les quantity-input
    const quantityInputs = document.querySelectorAll('quantity-input');
    
    quantityInputs.forEach(function(quantityContainer) {
        const minusBtn = quantityContainer.querySelector('button[name="minus"]');
        const plusBtn = quantityContainer.querySelector('button[name="plus"]');
        const input = quantityContainer.querySelector('.quantity__input');
        
        if (!minusBtn || !plusBtn || !input) return;
        
        // Fonction pour mettre à jour la quantité
        function updateQuantity(change) {
            const currentValue = parseInt(input.value) || 1;
            const minValue = parseInt(input.getAttribute('min')) || 1;
            const maxValue = parseInt(input.getAttribute('max')) || 999;
            
            let newValue = currentValue + change;
            
            // Vérifier les limites
            if (newValue < minValue) {
                newValue = minValue;
            } else if (newValue > maxValue) {
                newValue = maxValue;
            }
            
            // Mettre à jour la valeur
            input.value = newValue;
            
            // Déclencher l'événement change pour que d'autres scripts puissent réagir
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        // Gestionnaire pour le bouton moins (-)
        minusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            updateQuantity(-1);
        });
        
        // Gestionnaire pour le bouton plus (+)
        plusBtn.addEventListener('click', function(e) {
            e.preventDefault();
            updateQuantity(1);
        });
        
        // Gestionnaire pour l'input direct (validation)
        input.addEventListener('change', function() {
            const minValue = parseInt(this.getAttribute('min')) || 1;
            const maxValue = parseInt(this.getAttribute('max')) || 999;
            let value = parseInt(this.value) || minValue;
            
            if (value < minValue) {
                value = minValue;
            } else if (value > maxValue) {
                value = maxValue;
            }
            
            this.value = value;
        });
        
        // Empêcher la saisie de caractères non numériques
        input.addEventListener('keypress', function(e) {
            // Permettre seulement les chiffres, backspace, delete, tab, escape, enter
            if (!/[0-9]/.test(String.fromCharCode(e.which)) && 
                ![8, 9, 27, 13, 46].includes(e.which) &&
                // Permettre Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                !(e.which === 65 && e.ctrlKey) && 
                !(e.which === 67 && e.ctrlKey) && 
                !(e.which === 86 && e.ctrlKey) && 
                !(e.which === 88 && e.ctrlKey)) {
                e.preventDefault();
            }
        });
    });
    
    // Marquer le composant comme initialisé
    quantityInputs.forEach(function(element) {
        element.setAttribute('initialized', 'true');
    });
    
});